<header>
  <nav class="bg-gray-800">
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <a routerLink="/" class="inline-block align-middle">
              <img class="h-10 w-auto" src="assets/baird-logo.png" alt="Baird Logo" />
            </a>
            <a class="text-gray-200 hover:text-gray-200 px-3 py-2 rounded-md text-sm font-medium inline-block"
              routerLink="/">Tax Doc Notifier</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>